import { FitterVehicle } from '../fitter';
import { Itinerary, LocationDataGeocoded } from '../location';

export interface Appointment {
  id: string;
  fitterId: string;
  brandId?: string;
  time: string | Date;
  endTime?: string | Date;
  timezone: string;
  replacementVehicle?: boolean;
  isReplacementVehicleSelected?: boolean;
  outsideIntervention: boolean;
  interventionLocation?: LocationDataGeocoded;
  immobilisationDuration?: number;
  interventionDuration?: number;
  isInterventionDifficult?: boolean;
  totalCost?: number;
  extraCost?: number;
  status?: AppointmentStatus;
  reminderIsSent?: boolean;
  /*
   * NOTE - isValidatedByFitter MUST ALWAYS be null/undefined before being transferred to any fitter API (if not cancelled or abandonned)
   * This can then serve as a marker to know if the dossier is transferred to our agenda API (by setting it to false) and not turning this dossier state to DONE automatically
   */
  isValidatedByFitter?: boolean;
  /** @deprecated Read only for migration. Add comments to Dossier.dossierComments. */
  comment?: string;
  partAvailability?: PartAvailabilityStatus;
  assignedResources?: string[];
  assignedInterventionVehicle?: string;
  assignedReplacementVehicle?: FitterVehicle;
  assignedReplacementVehicleUse?: {
    start?: string;
    end?: string;
  };
  partProvider?: string;
  isConveying?: boolean;
  interventionId?: string;
  itinerary?: Itinerary;
}

export interface RequestAppointment
  extends Omit<
    Appointment,
    'id' | 'interventionDuration' | 'time' | 'endTime'
  > {}

export enum AppointmentStatusEnum {
  DRAFT = 'DRAFT',
  REQUESTED = 'REQUESTED',
  BOOKED = 'BOOKED',
  NO_SHOW = 'NO_SHOW',
  CANCELLED = 'CANCELLED',
  MODIFIED = 'MODIFIED',
  COMPLETED = 'COMPLETED',
  REQUESTED_AND_VALIDATED = 'REQUESTED_AND_VALIDATED',
}
export type AppointmentStatus = `${AppointmentStatusEnum}`;

export enum PartAvailabilityStatusEnum {
  UNAVAILABLE = 'UNAVAILABLE',
  ORDERED = 'ORDERED',
  AVAILABLE = 'AVAILABLE',
}
export type PartAvailabilityStatus = `${PartAvailabilityStatusEnum}`;

export enum AppointmentFilterEnum {
  NEW = 'NEW',
  PROGRAMMED = 'PROGRAMMED',
  COMPLETED = 'COMPLETED',
  ABANDONED = 'ABANDONED',
  NO_SHOW = 'NO_SHOW',
  CANCELLED = 'CANCELLED',
  DRAFT = 'DRAFT',
  REQUESTED = 'REQUESTED',
  REQUESTED_AND_VALIDATED = 'REQUESTED_AND_VALIDATED',
}
export type AppointmentFilter = `${AppointmentFilterEnum}`;

export enum AppointmentTypeEnum {
  OUTSIDE = 'OUTSIDE',
  IN_CENTER = 'IN_CENTER',
  CONVEYING = 'CONVEYING',
}
export type AppointmentType = `${AppointmentTypeEnum}`;
